import React from 'react';
import { Link } from 'react-router-dom';
import home from '../images/home-btn.png';
import back from '../images/back-btn.png';
import help from '../images/help-btn.png';

// Con onHelp, el sitio de la flecha de atras lo ocupa el boton de pistas.
const TwoButtons = ({ onHelp }) => {
    const handleGoBack = () => {
        window.history.back();
    };

    return (
        <div className="global-buttons-bh">
            <button className="main-button"><Link to="/"><img src={home} alt="home" /></Link></button>
            {onHelp ? (
                <button className="main-button help" onClick={onHelp}><img src={help} alt="pistas" /></button>
            ) : (
                <button className="main-button back" onClick={handleGoBack}><img src={back} alt="back" /></button>
            )}
        </div>
    );
};

export default TwoButtons;